// ALGOLIA
export const ALGOLIA_INDEX_SUFFIX = 'release_date';
